import { Flex, Pane, Text } from '@leverege/ui-elements'
import React from 'react'
import { formatPaceTimes } from '../Utils'
import S from './OverallPaceCard.css'
import usePaceOverviewCards from './hooks/usePaceOverviewCards'

function OverallPaceCard( { fgJob } ) {
  const { paces : { overall } } = usePaceOverviewCards( fgJob )

  return (
    <Flex gap={14} justify="space-between" wrap="wrap">
      <Pane variant="mobilePaceCard" className={S.card}>
        <Pane variant="mobilePaceCardHeader">
          <Flex variant="rowSpaceBetween" align="center">
            <Text variant="mobilePaceCardBigHeader">{overall.title}</Text>
            {overall.completed && (
              <Text variant={`tag${overall.status}`}>Completed</Text>
            )}
            {overall.stage && !overall.completed && (
              <Text variant="tagNeutral">{overall.stage}</Text>
            )}
          </Flex>
        </Pane>
        <Pane
          variant="mobilePaceCardArea"
          className={!overall.completed && S[`cardArea${overall.status}`]}>
          <Flex gap={10}>
            <Flex
              variant="colM"
              style={{
                flexGrow : 1,
                justifyContent : 'space-between',
                padding : '4px 10px 10px 0',
                borderRight : `1px solid ${
                  !overall.completed ? 'white' : '#67798E'
                }`,
              }}>
              <Text variant="paceCardDetailHeader">CT</Text>
              <Text variant={`mobilePace${overall.status}`}>{overall.currentPace}</Text>
            </Flex>
            <Flex variant="rowSpaceAround" style={{ flexGrow : 1 }} gap={10}>
              <Pane
                variant="detailBox"
                className={S.detailBox}
                style={{ flexGrow : 1 }}>
                <Flex variant="colM">
                  <Text variant="paceCardDetailHeader">Target CT</Text>
                  <Text variant="paceCardDetailContent">{overall.targetPace}</Text>
                </Flex>
              </Pane>
              <Pane
                variant="detailBox"
                className={S.detailBox}
                style={{ flexGrow : 1 }}>
                <Flex variant="colM">
                  <Text variant="paceCardDetailHeader">CT Difference</Text>
                  <Text
                    variant="paceCardDetailContent"
                    className={S[`paceCardDetailContent${overall.status}`]}>
                    {formatPaceTimes( overall.currentPace - overall.targetPace, {
                      signDisplay : 'always',
                    } )}
                  </Text>
                </Flex>
              </Pane>
            </Flex>
          </Flex>
        </Pane>
      </Pane>
    </Flex>
  )
}

export default OverallPaceCard
